import fetch from '../../api/fetch';
import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import store from '../store';
import { enqueueSnackbar } from './snackbar';

export const getUnassignedAssets = () => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.ASSETS_LOADING,
  });

  return fetch
    .post('assets/assets')
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }

      return result.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.ASSETS_SUCCESS,
        payload: {
          data: data.data,
          paginatedElements: data.data.length,
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );

      dispatch({
        type: REDUX_ACTIONS.ASSETS_DATA_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};

export const getAssetsList = (id) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.ASSETS_LIST_LOADING,
  });

  return fetch
    .post('assets/fetch', {
      asset_type_id: id
    })
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.ASSETS_LIST_SUCCESS,
        payload: {
          data: data.data,
          paginatedElements: data.data.length,
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);

      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.ASSETS_LIST_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};

export const addNewAsset = (rowValues) => (dispatch) => {
  const { assets } = store.getState();
  const newAssets = [...assets.assetsList.data];
  const nextId = newAssets.length - 1;

  function generateRandom() {
    const length = 24;
    const charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let retVal = '';
    for (let i = 0, n = charset.length; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
  }

  const newRow = {
    ...rowValues,
    grid_id: nextId + 1,
    _id: generateRandom(),
    isNewRow: true,
    isDirty: true
  };
  newAssets.unshift(newRow);

  dispatch({
    type: REDUX_ACTIONS.ASSETS_LIST_SUCCESS,
    payload: {
      data: newAssets,
      paginatedElements: newAssets.length,
    },
  });
};

export const deleteNewAssetRow = (_id) => (dispatch) => {
  const { assets } = store.getState();
  const assetsData = [...assets.assetsList.data];

  const updatedData = assetsData?.filter(item => item?._id !== _id);

  dispatch({
    type: REDUX_ACTIONS.ASSETS_LIST_SUCCESS,
    payload: {
      data: updatedData,
      paginatedElements: updatedData.length,
    },
  });
};

export const updateAsset = (body, id) => (dispatch) => {
  return fetch
    .put('assets', { asset_type_id: id, input: body })
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Asset Updated Successfully.',
          'success',
          new Date().getTime() + Math.random()
        )
      );
      dispatch(getAssetsList(id));
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
    });
};

export const deleteAsset = (body, id, handleClose) => (dispatch) => {
  return fetch
    .deleteAction('assets', { asset_type_id: id, input: body })
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      handleClose();
      dispatch(getAssetsList(id));
      dispatch(
        enqueueSnackbar(
          'Asset deleted',
          'success',
          new Date().getTime() + Math.random()
        )
      );
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      handleClose();
    });
};

export const createAsset = (body, id) => (dispatch) => {
  return fetch
    .post('assets/create', { asset_type_id: id, input: body })
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Asset Created Successfully.',
          'success',
          new Date().getTime() + Math.random()
        )
      );
      dispatch(getAssetsList(id));
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
    });
};

export const createMpdAsset = (body) => (dispatch) => {
  delete body.isNewRow;
  delete body._id;
  const input = {
    input: {
      ...body,
    }
  };
  return fetch
    .post('mpdAssets/create', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Asset Created Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(getUnassignedAssets());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(getUnassignedAssets());
    });
};
export const updateMpdAsset = (body) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.ASSETS_LOADING,
  });
  const input = {
    query: {
      _id: body?._id
    },
    input: {
      SN: body.SN,
      Type: body.Type,
      jobId: body.jobId,
    }
  };
  return fetch
    .put('mpdAssets', input)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Asset Updated Successfully.',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(getUnassignedAssets());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(getUnassignedAssets());
    });
};
export const deleteMpdAsset = (_id) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.ASSETS_LOADING,
  });
  const body = {
    query: {
      _id,
    }
  };
  return fetch
    .deleteAction('mpdAssets', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(() => {
      dispatch(
        enqueueSnackbar(
          'Asset Deleted successfully',
          'success',
          new Date().getTime() + Math.random()
        ));
      dispatch(getUnassignedAssets());
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        ));
      dispatch(getUnassignedAssets());
    });
};
